<template>
  <div class="layout">
    <div class="header">
      <div class="logo">病原微生物数据库</div>
      <!-- <div class="logo">人呼吸道本底微生物基因组数据库</div> -->
    </div>
    <div class="body">
      <div class="sidebar">
        <CategorySidebar title="分类" :data="categories" v-model="activeSubCategory" @change="handleSearch" />
        <CategorySidebar title="宿主" :data="hostList" v-model="hostCategory" @change="handleSearch" />
      </div>


      <main class="content">
        <div class="toolbar">
          <el-input v-model="searchKeyword" placeholder="搜索名称、参考株或疾病..." clearable class="search-input"
            @clear="handleSearch" @keyup.enter="handleSearch">
            <template #append>
              <el-button :icon="Search" @click="handleSearch">查询</el-button>
            </template>
          </el-input>
          <el-tag v-if="activeSubCategory" closable @close="closeTagFunc('type')" class="filter-tag">
            分类: {{ activeSubCategory }}
          </el-tag>
          <el-tag v-if="hostCategory" closable @close="closeTagFunc('host')" class="filter-tag">
            宿主: {{ hostCategory }}
          </el-tag>
        </div>
        <div class="table-card">
          <el-table :data="rawTableData" stripe border v-loading="loading" style="width: 100%"
            header-cell-class-name="pro-table-header" :heigth="500">
            <el-table-column prop="id" label="Taxonomy" width="120" />
            <el-table-column label="名称" min-width="220">
              <template #default="{ row }">
                <el-link type="primary" :underline="false" @click="goDetail(row)" class="font-bold">
                  {{ row.name_txt || 'Unknown' }}
                </el-link>
                <div class="sub-name">
                  {{ row.name_txt_zh }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="参考株(ref)" width="150">
              <template #default="{ row }">
                <div v-if="row.genome_info && row.genome_info.length">
                  <div v-for="item in row.genome_info.slice(0, 3)" :key="item.accession">
                    <el-link type="primary" style="font-size: 12px; line-height: 1.6;"
                      @click.stop="goNcbi(item.accession)">
                      {{ item.accession }}
                    </el-link>
                  </div>

                  <div v-if="row.genome_info.length > 3" style="margin-top: 4px;">
                    <el-text type="info" size="small" style="font-size: 11px;">更多请查看详情...</el-text>
                  </div>
                </div>
                <span v-else style="color: #ccc;">-</span>
              </template>
            </el-table-column>
            <el-table-column prop="epidemic_and_representative_strain" label="流行株/代表株" width="180" />
            <el-table-column label="全部样本数" width="110" align="center">
              <template #default="{ row }">
                <el-button link type="success" @click="goSampleList(row)">
                  {{ row.samples_count }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="category_zh" label="分类" width="90" align="center" />
            <el-table-column prop="disease" label="疾病" width="140">
              <template #default="{ row }">
                <div v-if="row.diseases && row.diseases.length">
                  <div v-for="item in row.diseases.slice(0, 2)" :key="item.id">{{item.name}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="host" label="宿主" width="120" />
            <el-table-column prop="isolation_country" label="分离国家" width="120" />
            <el-table-column label="操作" width="100" fixed="right" align="center">
              <template #default="{ row }">
                <el-button type="primary" link @click="goNextstrain(row)" :disabled="!row.nextstrain">
                  nextstrain
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :total="total" :page-size="per_page"
              :current-page="page" @current-change="handlePageChange" />
          </div>
        </div>
      </main>
    </div>

    <el-drawer v-model="drawer" size="650px" destroy-on-close :title="currentRow?.name_txt">
      <div v-if="currentRow" class="detail-container">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="ID / Genome ID">
            {{ currentRow.id }} <span v-if="currentRow.genome_id">({{ currentRow.genome_id }})</span>
          </el-descriptions-item>

          <el-descriptions-item label="学名 (Scientific Name)">
            <i style="font-weight: bold;">{{ currentRow.name_txt }}</i>
          </el-descriptions-item>

          <el-descriptions-item label="中文名">
            {{ currentRow.name_txt_zh || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="分类层级 (Taxonomy)">
            <div class="tax-path">
              <el-tag size="small" effect="plain" v-if="currentRow.superkingdom">{{ currentRow.superkingdom }}</el-tag>
              <span v-if="currentRow.phylum"> / {{ currentRow.phylum }}</span>
              <span v-if="currentRow.clas"> / {{ currentRow.clas }}</span>
              <span v-if="currentRow.orders"> / {{ currentRow.orders }}</span>
              <span v-if="currentRow.family"> / {{ currentRow.family }}</span>
              <span v-if="currentRow.genus"> / <b>{{ currentRow.genus }}</b></span>
            </div>
          </el-descriptions-item>

          <el-descriptions-item label="全部参考株 (Accession)">
            <div v-if="currentRow.genome_info && currentRow.genome_info.length" class="accession-detail-list">
              <div v-for="item in currentRow.genome_info" :key="item.accession" class="accession-detail-item">
                <el-link type="primary" @click="goNcbi(item.accession)" style="font-weight: bold;">
                  {{ item.accession }}
                </el-link>
                <span class="assembly-text"> (Assembly: {{ item.assembly }})</span>
              </div>
            </div>
            <span v-else>-</span>
          </el-descriptions-item>

          <el-descriptions-item label="宿主 (Host)">
            {{ currentRow.host || '未知' }}
          </el-descriptions-item>

          <el-descriptions-item label="分离国家 (Isolation Country)">
            {{ currentRow.isolation_country || '-' }}
          </el-descriptions-item>

          <el-descriptions-item label="分类类别">
            {{ currentRow.category_zh }}
          </el-descriptions-item>

          <el-descriptions-item label="相关疾病">
            <div v-if="currentRow.diseases && currentRow.diseases.length">
              <el-tag v-for="item in currentRow.diseases" :key="item.id" type="danger" size="small">{{ item.name
                }}</el-tag>
            </div>
            <span v-else>-</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-drawer>


  </div>
</template>

<script setup>
  import { ref, computed, onMounted } from "vue";
  import { ArrowRight, Search, UserFilled } from "@element-plus/icons-vue";
  import { get_data_list } from "@/api/index.js";
  import tetsJson from "./test.json";

  //src\views\Home\comps\CategorySidebar.vue
  import CategorySidebar from "./comps/CategorySidebar.vue";

  // --- 状态定义 ---
  const searchKeyword = ref("");
  const activeSubCategory = ref("");
  const hostCategory = ref(""); // 宿主
  const loading = ref(false);
  const drawer = ref(false);
  const currentRow = ref(null);
  const openParents = ref(["细菌", "病毒"]); // 默认展开项

  const page = ref(1)
  const per_page = ref(10)
  const total = ref(0)

  // --- 静态数据 (实际开发中从 API 获取) ---
  const categories = ref([
    {
      key: "细菌", label: "细菌", doc_count: 1000,
      children: [{ key: "肠道菌", label: "肠道菌", doc_count: 123 }, { key: "肝炎菌", label: "肝炎菌", doc_count: 456 }]
    }
  ]);
  const rawTableData = ref([]);

  //宿主列表
  const hostList = ref([]);

  // --- 方法 ---
  const toggleParent = (name) => {
    const idx = openParents.value.indexOf(name);
    idx > -1 ? openParents.value.splice(idx, 1) : openParents.value.push(name);
  };

  const handleSearch = () => {
    page.value = 1;
    getData();
  };

  // 跳转 NCBI 页面
  const goNcbi = (accession) => {
    if (!accession) return;
    const url = `https://www.ncbi.nlm.nih.gov/datasets/genome/${accession}/`;
    window.open(url, '_blank');
  };

  const handlePageChange = (p) => {
    page.value = p;
    getData();
  };

  const goDetail = (row) => {
    // 模拟根据 ID 获取详情
    currentRow.value = { ...row };
    drawer.value = true;
  };

  const goNextstrain = (row) => {
    // window.open("https://nextstrain.org");
    if (row.nextstrain) window.open(row.nextstrain);
  }
  const goSampleList = (row) => console.log("跳转至样本列表", row.name);

  const getData = async () => {
    loading.value = true;
    try {
      const res = await get_data_list({
        q: searchKeyword.value,
        page: page.value,
        per_page: per_page.value,
        type: activeSubCategory.value,
        host: hostCategory.value
      });
      const result = res.data || res;
      rawTableData.value = result || [];
      categories.value = res?.count;
      hostList.value = res?.host_distribution;
      total.value = res.total;
    } catch (error) {
      console.error("获取数据失败", error)
    } finally {
      loading.value = false
    }
  };


  const closeTagFunc = (type) => {
    if (type === 'type') {
      activeSubCategory.value = "";
    } else if (type === 'host') {
      hostCategory.value = "";
    }
    getData();
  }

  onMounted(() => {
    getData();
  });
</script>

<style scoped>
  /* 布局与整体结构 */
  .layout {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #f5f7fa;
    font-family: Inter, -apple-system, sans-serif;
  }

  .header {
    height: 64px;
    background: linear-gradient(90deg, #1e3c72, #2a5298);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    color: #fff;
    font-size: 18px;
    letter-spacing: 1px;
  }

  .logo {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 1px;
  }

  .body {
    flex: 1;
    display: flex;
    overflow: hidden;
  }

  /* 侧边栏优化 */
  .sidebar {
    width: 260px;
    background: #fff;
    border-right: 1px solid #e0e6ed;
    padding: 16px 8px;
    overflow-y: auto;
  }

  .category-parent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.2s;
  }

  .category-parent:hover {
    background: #f0f4ff;
  }

  .parent-left {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 15px;
    font-weight: 500;
  }

  .arrow {
    font-size: 12px;
    transition: transform 0.3s;
  }

  .arrow.open {
    transform: rotate(90deg);
  }

  .category-children {
    padding-left: 28px;
    margin-top: 4px;
  }

  .category-child {
    display: flex;
    justify-content: space-between;
    padding: 8px 12px;
    margin: 2px 0;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13.5px;
    color: #606266;
  }

  .category-child:hover {
    background: #f5f7fa;
    color: #2a5298;
  }

  .category-child.active {
    background: #e8f0ff;
    color: #2a5298;
    font-weight: 600;
  }

  /* 内容区优化 */
  .content {
    flex: 1;
    padding: 24px;
    overflow-y: auto;
  }

  .toolbar {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .search-input {
    width: 450px;
    box-shadow: 0 2px 12px -2px rgba(0, 0, 0, 0.05);
  }

  .filter-tag {
    height: 32px;
  }

  .table-card {
    background: #fff;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  :deep(.pro-table-header) {
    background-color: #f8f9fb !important;
    color: #303133;
    font-weight: bold;
  }

  .font-bold {
    font-weight: 600;
  }

  .pagination {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  }

  /* 详情页样式 */
  .detail-section {
    padding: 4px;
  }

  .section-title {
    margin: 16px 0 10px;
    color: #1a2a4c;
    border-left: 4px solid #2a5298;
    padding-left: 10px;
  }

  .description {
    color: #666;
    line-height: 1.6;
    font-size: 14px;
    margin-bottom: 15px;
  }

  .tag-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  /* 展开动画 */
  .expand-enter-active,
  .expand-leave-active {
    transition: all 0.3s ease;
    max-height: 300px;
    overflow: hidden;
  }

  .expand-enter-from,
  .expand-leave-to {
    max-height: 0;
    opacity: 0;
  }



  .detail-container {
    padding: 20px;
  }

  .tax-path {
    line-height: 1.6;
    color: #606266;
  }

  .accession-detail-list {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #f0f0f0;
    padding: 10px;
    background: #fafafa;
    border-radius: 4px;
  }

  .accession-detail-item {
    padding: 4px 0;
    border-bottom: 1px dashed #eee;
  }

  .accession-detail-item:last-child {
    border-bottom: none;
  }

  .assembly-text {
    font-size: 12px;
    color: #909399;
    margin-left: 8px;
  }
</style>